<component  v-if="shouldRenderConfig" v-bind:is="getContainerType" v-bind:class="getClassName">
    <appPackingOptions
        v-for="(option,index) in getPackingOptions"
        v-bind:key="index"
        v-bind:propsData="option"
    >
    </appPackingOptions>
</component>